export class Comentario {
  comentario: string;
  creadoPor: string;
  fecha: string;
  fechaCreado: string;
  fechaLeido: string;
  id: number | string;
  leido: boolean;
  leidoPor: any[];
  comentarios: Comentario[];
  fechaCortaCreado: string;

  targetID: string | number;
  origen: string;

  responder = false;
  editando = false;
  isEditable = false;

  constructor(comentario: {
    comentario: string,
    creadoPor?: string,
    fecha?: string,
    fechaCreado?: string,
    fechaLeido?: string,
    id: number | string,
    leido?: boolean,
    leidoPor?: string[],
    comentarios?: Comentario[],
    isEditable?: boolean
  }) {
    this.comentario = comentario.comentario;
    this.creadoPor = comentario.creadoPor || '';
    this.fecha = comentario.fecha || '';
    this.fechaCreado = comentario.fechaCreado || new Date().toString();
    this.fechaLeido = comentario.fechaLeido || '';
    this.id = comentario.id;
    this.leido = comentario.leido || false;
    this.leidoPor = comentario.leidoPor || [];
    this.comentarios = comentario.comentarios || [];
    this.isEditable = comentario.isEditable;
  }
}
